module.exports = __webpack_public_path__ + "img/wire_logic-2.6b03286c.jpg";